export default class SubmissionHttp {
  static get #requestOptions() {
    return {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').getAttribute("content"),
      },
    };
  }

  static #handleResponse(response) {
    return response.json().then((resObj) => {
      if (!response.ok) {
        const error = (resObj && resObj.message) || response.statusText;
        return Promise.reject(error);
      }

      return resObj;
    });
  }

  static request(url, { method = "GET", body } = {}) {
    return fetch(url, { ...this.#requestOptions, method, body }).then(this.#handleResponse);
  }

  static #getResourceName(submissionType) {
    switch (submissionType) {
      case "pharmacy":
        return "field_mappings";
      case "medical":
        return "medical_field_mappings";
      case "pharmacy_encounter":
        return "pharmacy_encounter_field_mappings";
      case "medical_encounter":
        return "medical_encounter_field_mappings";
    }
  }

  static getSalt(organizationID) {
    const url = `/api/organization/${organizationID}/vault`;

    return this.request(url);
  }

  static createFieldMapping(path, name, fields, submissionType) {
    const requestOptions = {
      method: "POST",
      body: JSON.stringify({
        [this.#getResourceName(submissionType)]: {
          name,
          ...fields,
        },
      }),
    };

    return this.request(path, requestOptions);
  }

  static updateFieldMapping(path, id, changes, submissionType) {
    const url = `${path}/${id}`;

    const requestOptions = {
      method: "PUT",
      body: JSON.stringify({
        [this.#getResourceName(submissionType)]: changes,
      }),
    };

    return this.request(url, requestOptions);
  }

  static deleteMappingGroup(path, id) {
    const url = `${path}/${id}`;

    const requestOptions = {
      method: "DELETE",
    };

    return this.request(url, requestOptions);
  }
}
